module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "gray-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.t_data.base.title))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.t_data.base.subtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "floors"
  }, _vm._l((_vm.t_data.data), function(item, j) {
    return _c('div', {
      staticClass: "good-item"
    }, [_c('div', {}, [_c('div', {
      staticClass: "good-img"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })]), _vm._v(" "), _c('h6', {
      staticClass: "good-title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('h3', {
      staticClass: "sub-title ellipsis"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "good-price pr"
    }, [_c('div', {
      class: [this.usage === 'store' ? 'ds' : 'ds-n', 'pa']
    }, [_c('y-button', {
      staticStyle: {
        "margin": "0 5px"
      },
      attrs: {
        "text": "查看详情"
      }
    }), _vm._v(" "), _c('y-button', {
      staticStyle: {
        "margin": "0 5px"
      },
      attrs: {
        "text": "加入购物车",
        "classStyle": "main-btn"
      }
    })], 1), _vm._v(" "), _c('p', [_vm._v("¥ " + _vm._s((Number(item.price) / 100).toFixed(2)))])])])])
  }), 0)])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42c1af4f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42c1af4f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/homePage/components/plugins/goodsGrid/index.vue
// module id = 2671
// module chunks = 0